module.exports = __webpack_public_path__ + "img/bmp.24a47fe.svg";